import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { RadioGroup, Typography } from '@mui/material';
import {
  ProgramWizardCurrentProgram,
  ProgramWizardCurrentProgramId,
  ProgramWizardOperatingMode,
} from '../ProgramWizard.types';
import WizardRadioButton from '../WizardRadioButton';

export type PeakshaveMode = {
  key: string;
  text: string;
  disabled?: boolean;
  operatingMode: ProgramWizardOperatingMode;
};

type StepPeakshaveModeProps = {
  currentProgram?: ProgramWizardCurrentProgram | null;
  selected: PeakshaveMode | null;
  onSelect: (option: PeakshaveMode) => void;
};

const StepPeakshaveMode = ({ currentProgram, selected, onSelect }: StepPeakshaveModeProps) => {
  const { t } = useTranslation('programWizard');

  const options: PeakshaveMode[] = [
    {
      key: 'grid',
      text: t('genOrGrid.grid'),
      disabled: currentProgram?.id === ProgramWizardCurrentProgramId.GRID_PEAKSHAVE,
      operatingMode: ProgramWizardOperatingMode.GRID,
    },
    {
      key: 'genset',
      text: t('genOrGrid.genset'),
      disabled: currentProgram?.id === ProgramWizardCurrentProgramId.GEN_SET_PEAKSHAVE,
      operatingMode: ProgramWizardOperatingMode.GENSETS,
    },
  ];

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const option = options.find((o) => o.key === event.target.value);
    if (option) {
      onSelect(option);
    }
  };

  return (
    <>
      <Typography variant="subtitle1" color="text.secondary">
        {t('genOrGrid.question')}
      </Typography>

      <RadioGroup value={selected?.key ?? ''} onChange={handleChange} sx={{ flexDirection: 'row', gap: 2 }}>
        {options.map((option) => (
          <WizardRadioButton key={option.key} value={option.key} text={option.text} disabled={option.disabled} />
        ))}
      </RadioGroup>
    </>
  );
};

export default StepPeakshaveMode;
